import * as React from 'react';
import { Text } from '@grandvisionhq/iris-ui';
import { Linkify } from '@grandvisionhq/lib-utils-react';
import { useIntl } from '@grandvisionhq/state';
import { ProductDetailDrawer } from '../../ProductDetailDrawer/ProductDetailDrawer.js';
import { ProductDetailManufacturerCTA } from './components/ProductDetailManufacturerCTA/ProductDetailManufacturerCTA.js';

const ProductDetailManufacturer = ({ title , city , country , contactUrl , email , line1 , line2 , line3 , name , zipCode , shouldMountContent =false ,  })=>{
    const { getLabel  } = useIntl();
    const address = Boolean(city && country && (line1 || line2 || line3) && zipCode);
    const spacing = [
        'mb-0'
    ];
    return /*#__PURE__*/ React.createElement(ProductDetailDrawer, {
        title: title,
        "data-t": "manufacturer-drawer",
        ctaButton: /*#__PURE__*/ React.createElement(ProductDetailManufacturerCTA, {
            title: title
        }),
        shouldMountContent: shouldMountContent
    }, /*#__PURE__*/ React.createElement("address", {
        className: "product-detail-manufacturer__content"
    }, name ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-manufacturer__content-section"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        spacings: spacing,
        component: "h3"
    }, getLabel('products.detail.manufacturer.name')), /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, name)) : null, contactUrl || email ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-manufacturer__content-section"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        spacings: spacing,
        component: "h3"
    }, getLabel('products.detail.manufacturer.electronicAddress')), contactUrl && /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, /*#__PURE__*/ React.createElement(Linkify, {
        shouldOpenInNewTab: true
    }, contactUrl)), email && /*#__PURE__*/ React.createElement(Text, {
        variant: "body"
    }, /*#__PURE__*/ React.createElement(Linkify, null, email))) : null, address ? /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-manufacturer__content-section"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head",
        spacings: spacing,
        component: "h3"
    }, getLabel('products.detail.manufacturer.postalAddress')), line1 ? /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        spacings: spacing
    }, line1) : null, line2 ? /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        spacings: spacing
    }, line2) : null, line3 ? /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        spacings: spacing
    }, line3) : null, city || zipCode ? /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        spacings: spacing
    }, `${city}${city && zipCode ? ', ' : ''}${zipCode}`) : null, country ? /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        spacings: spacing
    }, country) : null) : null));
};

export { ProductDetailManufacturer };
//# sourceMappingURL=ProductDetailManufacturer.js.map
